import { Button } from 'components/ui/button';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';

interface CookieConsentProps {
  cookieName?: string;
  cookieValue?: string;
  expires?: number;
}

const CookieConsent = ({ cookieName = 'consent', cookieValue = 'consented', expires = 365 }: CookieConsentProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (Cookies.get(cookieName) === undefined) {
      setVisible(true);
    }
  }, [cookieName]);

  const handleAccept = () => {
    Cookies.set(cookieName, cookieValue, { expires });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] flex justify-center p-4">
      <div className="flex items-center gap-4 max-w-3xl rounded-lg border bg-popover text-popover-foreground shadow-lg px-4 py-3 text-sm">
        <span>
          By clicking &apos;Accept&apos; or continuing to use our site, you acknowledge that you accept our <a target="_blank" rel="noopener noreferrer" className="underline underline-offset-4" href="https://www.oilytics.co/privacy-policy">Privacy Policy</a> and <a className="underline underline-offset-4" target="_blank" rel="noopener noreferrer" href="https://www.oilytics.co/terms-of-use">Terms of Use</a>. We also use cookies to provide you with the best possible experience on our website.
        </span>
        <Button
          size="sm"
          className="shrink-0"
          onClick={handleAccept}
        >
          Accept
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;
